<template>
  <div>
    <Slot />
  </div>
</template>

<script>
export default {
  name: 'PageTitle',
  props: {
    title: {
      type: String,
      required: true
    }
  },
  created () {
    document.title = this.title
  },
  watch: {
    title (newTitle) {
      document.title = newTitle
    }
  }
}
</script>
